/**
 * Copyright (c) 2025 Aisle 24. All rights reserved.
 *
 * Proprietary Software - Licensed for Internal Use Only
 *
 * This software and associated documentation files (the "Software") are proprietary
 * to Aisle 24 and are protected by copyright laws and international copyright
 * treaties, as well as other intellectual property laws and treaties.
 *
 * The Software is licensed, not sold, to you for use only under the terms of this
 * license agreement. All rights not expressly granted to you are reserved by Aisle 24.
 *
 * Unauthorized copying, modification, distribution, or use of this Software,
 * via any medium is strictly prohibited and may result in severe civil and
 * criminal penalties, and will be prosecuted to the maximum extent possible
 * under the law.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service worker registration disabled to prevent permission issues
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/sw.js')
//       .then((registration) => {
//         console.log('SW registered: ', registration);
//       })
//       .catch((registrationError) => {
//         console.log('SW registration failed: ', registrationError);
//       });
//   });
// }
